export default (target: string) => {
  return target === '_blank' ? 'nofollow noopener noreferrer' : null
}
